export const FLAG_CREATOR_REPORT = 'admin_app_creator_report'
export const FLAG_ADVERTISER_REPORT = 'admin_app_advertiser_report'
export const FLAG_CONTENT_DETAIL_MODAL = 'admin_app_content_detail_modal'
export const FLAG_CONTENT_POST_REEL_IMPORT = 'admin_app_content_post_reel_import'
export const FLAG_CAMPAIGN_PAYMENT_SPLIT = 'admin_app_campaign_payment_split'
export const FLAG_MARKETING_NOTIFICATIONS = 'admin_app_marketing_notifications'
